/*@ngInject*/
const CoreMediator = function ($rootScope, $state, $cookies, $q, $injector, $uibModalStack, $window, revisionRepository, loginRepository, loadUserDetailsRepository, alertHandler,
                               loadProfileImageRepository, userProfileRepository, currentUserModel, notificationPreferenceRepository, coreConstant,
                               uiPerformanceLogRepository, sendEmailNotificationRepository, loginTokenRepository, peoplePickerRepository, preferenceModel,
                               forgotPasswordRepository, repeatingFormDynamicDataSetFormSetIdRepository, clientIdRepository, userImageRepository, deleteUserImageRepository,
                               currentUserProfileRepository, updateUserProfileRepository, updateUserPreferencesRepository,
                               defaultPreferencesRepository, userPreferencesRepository, configuredFileRepository, configuredFileDataRepository, notificationRepository, registrationRepository, chatRoomRepository,
                               umRevisionRepository, appTypeConfigurationModel, refreshLoginTokenUtil, cachedDataSetsRepository, dataSetRepository, serverAckRepository,
                               temporaryLoginTokenRepository, organizationRepository) {

    let _persistentConnection;
    let self = this;
    let userDetailDefer;
    let dataSetNameToTypeMap;

    function getPersistentConnection() {
        if (!_persistentConnection) {
            _persistentConnection = $injector.get('persistentConnection');
        }
        return _persistentConnection;
    }

    function loadUserDetails() {
        if (userDetailDefer) {
            return userDetailDefer.promise;
        } else {
            userDetailDefer = $q.defer();
        }

        function handleSuccess(userProfile) {
            currentUserModel.setCurrentUser(userProfile);

            self.loadUserPreferences().then(function () {
                userDetailDefer.resolve();
                userDetailDefer = null;
            });
        }

        function handleError() {
            userDetailDefer.reject();
            userDetailDefer = null;
        }

        loadUserDetailsRepository.loadUserDetails().then(handleSuccess, handleError);

        return userDetailDefer.promise;
    }

    this.refreshUserDetails = function () {
        loadUserDetailsRepository.clearCache();
        return loadUserDetailsRepository.loadUserDetails().then(function (userProfile) {
            currentUserModel.setCurrentUser(userProfile);
        });
    };

    this.bootstrapApplication = function () {
        let defer = $q.defer();

        getPersistentConnection().connect().then(function () {
            this.loadDefaultPreferences().then(function () {
                this.fetchApplicationData().then(function () {
                    $rootScope.$broadcast(coreConstant.event.KEEPALIVE_PING);
                    $rootScope.$broadcast(coreConstant.event.APPLICATION_READY);
                    $rootScope.$broadcast(coreConstant.event.START_IDLE);
                    defer.resolve();
                });
            }.bind(this));
        }.bind(this));

        return defer.promise;
    };

    this.getRevision = function () {
        return revisionRepository.getRevision();
    };

    this.getUmVersionNumber = function () {
        return umRevisionRepository.getUmVersionNumber();
    };

    this.login = function (username, password, timeoutSeconds, passwordIsToken, isExternalToken) {
        let deferred = $q.defer();

        function handleSuccess(loginToken) {
            function handleRefreshLoginTokenSuccess() {
                function handleUserDetailsSuccess() {
                    deferred.resolve();
                }

                function handleUserDetailsError() {
                    deferred.reject();
                }

                loadUserDetails().then(handleUserDetailsSuccess, handleUserDetailsError);
            }

            function handleRefreshLoginTokenError() {
                deferred.reject();
            }

            refreshLoginTokenUtil.start(loginToken).then(handleRefreshLoginTokenSuccess, handleRefreshLoginTokenError);
        }

        function handleLoginError(error) {
            deferred.reject(error);
        }

        loginRepository.login(username, password, timeoutSeconds, passwordIsToken, isExternalToken).then(handleSuccess, handleLoginError);

        return deferred.promise;
    };

    this.disconnect = function (isAutoLogout) {
        const deferred = $q.defer();
        getPersistentConnection().disconnect().finally(function() {
            deferred.resolve();
        });
        return deferred.promise;
    };

    this.logout = function (isAutoLogout) {
        const logoutUrl = this.getLogoutUrl(isAutoLogout);
        let deferred = $q.defer();
        $uibModalStack.dismissAll();
        alertHandler.clearRegisteredChannels();
        loginRepository.logout().then(() => {
            self.disconnect().finally(function () {
                currentUserModel.reset();
                self.removeLoginToken();
                self.removeClientId();
                loadUserDetailsRepository.clearCache();
                defaultPreferencesRepository.clearCache();
                preferenceModel.reset();
                $rootScope.$broadcast(coreConstant.event.STOP_KEEPALIVE_PING);
                refreshLoginTokenUtil.stop();
                $rootScope.$broadcast(coreConstant.event.STOP_IDLE);

                if(!_.isEmpty(logoutUrl) && !_.isEmpty(logoutUrl.trim())){
                    $window.open(logoutUrl, '_self');
                }else {
                    $state.go('login');
                }
                $rootScope.$broadcast(coreConstant.event.LOGOUT_COMPLETE);
                deferred.resolve();
            });
        }, function(error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    this.fetchApplicationData = function () {
        return loadUserDetails().then(function () {
            return this.buildDataSetNameToTypeMap();
        }.bind(this));
    };

    // this will go away when we remove data fetcher -rc
    this.loadUserProfile = function () {
        return loadUserDetailsRepository.loadUserDetails();
    };

    this.loadProfileImage = function (userId) {
        return loadProfileImageRepository.loadProfileImage(userId);
    };

    this.loadUser = function () {
        return currentUserProfileRepository.loadUser();
    };

    this.loadUserById = function (id, submissionId, notificationId, chatMessageId, emailMessageId) {
        return userProfileRepository.loadUserById(id, submissionId, notificationId, chatMessageId, emailMessageId);
    };

    this.loadOrganizationById = function(organizationId){
        return organizationRepository.loadOrganizationById(organizationId);
    };

    this.updateUser = function (data) {
        return updateUserProfileRepository.updateUser(data);
    };

    this.updateUserImage = function (file, imageWidth, imageHeight) {
        return userImageRepository.updateUserImage(file, imageWidth, imageHeight);
    };

    this.deleteUserImage = function () {
        return deleteUserImageRepository.deleteUserImage();
    };

    this.loadUsersList = function (submissionId) {
        return peoplePickerRepository.loadUsersList(submissionId);
    };

    this.getChatNotificationRecipients = function (submissionId) {
        return chatRoomRepository.getChatNotificationRecipients(submissionId);
    };

    this.loadDefaultPreferences = function () {
        return defaultPreferencesRepository.loadDefaultPreferences();
    };

    this.loadUserPreferences = function () {
        return userPreferencesRepository.loadUserPreferences();
    };

    this.getCachedDataSetByName = function (dataSetName) {
        return cachedDataSetsRepository.getDataSet(dataSetName);
    };

    this.getRemoteDataSetByName = function (dataSetName) {
        return dataSetRepository.getDataSet(dataSetName);
    };

    this.buildDataSetNameToTypeMap = function () {
        dataSetNameToTypeMap = {};

        return dataSetRepository.getDataSetNameToTypeMap().then(function (map) {
            dataSetNameToTypeMap = map;
        });
    };

    this.getDataSetNameToTypeMap = function () {
        return dataSetNameToTypeMap;
    };

    this.getDynamicDataSet = function (params, registrationId, isNotFormRelated) {
        return dataSetRepository.getDynamicDataSet(params, registrationId, isNotFormRelated);
    };

    this.getDynamicDataSetItems = function (params, registrationId, isNotFormRelated) {
        return dataSetRepository.getDynamicDataSetItems(params, registrationId, isNotFormRelated);
    };

    this.unregisterDynamicDataset = function (params, registrationId) {
        return dataSetRepository.unregisterDynamicDataset(params, registrationId);
    };

    this.getRepeatingFormDynamicDataSetFormSetId = function (formId, dynamicDataSetName) {
        return repeatingFormDynamicDataSetFormSetIdRepository.getOwningFormSetId(formId, dynamicDataSetName);
    };

    this.getNotificationPopupTemplate = function (name, context) {
        return notificationPreferenceRepository.getNotificationPopupTemplate(name, context);
    };

    this.getNotificationEmailTemplate = function (name, context) {
        return notificationPreferenceRepository.getNotificationEmailTemplate(name, context);
    };

    this.updateUserPreferences = function (key, value) {
        let data = {};
        data[key] = value;
        return updateUserPreferencesRepository.updateUserPreferences(data).then(function () {
            preferenceModel.set(key, value);
        });
    };

    this.getPreferenceByName = function (name) {
        return preferenceModel.get(name);
    };

    this.createUiPerformanceLog = function (log) {
        return uiPerformanceLogRepository.createUiPerformanceLog(log);
    };

    this.sendEmailNotification = function (notificationName, isCustom, submissionId, options) {
        return sendEmailNotificationRepository.sendEmailNotification(notificationName, isCustom, submissionId, options);
    };

    this.getLoginToken = function () {
        return loginTokenRepository.getLoginToken();
    };

    this.getLoginTokenAuthorizationHeader = function () {
        return loginTokenRepository.getLoginTokenAuthorizationHeader();
    };

    this.getSingleUseToken = function () {
        return temporaryLoginTokenRepository.getSingleUseToken();
    };

    this.setLoginToken = function (loginToken) {
        loginTokenRepository.setLoginToken(loginToken);
    };

    this.removeLoginToken = function () {
        loginTokenRepository.removeLoginToken();
    };

    this.getClientId = function () {
        return clientIdRepository.getClientId();
    };

    this.setClientId = function (clientId) {
        clientIdRepository.setClientId(clientId);
    };

    this.removeClientId = function () {
        clientIdRepository.removeClientId();
    };

    this.forgotPassword = function (username, emailAddress) {
        return forgotPasswordRepository.forgotPassword(username, emailAddress);
    };

    this.isUserLoggedIn = function () {
        return !_.isNil(currentUserModel.getCurrentUser());
    };

    this.getConfiguredFile = function (name) {
        return configuredFileRepository.find(name);
    };

    this.getConfiguredFileData = function (id) {
        return configuredFileDataRepository.getData(id);
    };

    this.findByNotifiedUserId = function (userId, type, startingIndex, numberOfRows, latest, unreadOnly) {
        return notificationRepository.findByNotifiedUserId(userId, type, startingIndex, numberOfRows, latest, unreadOnly);
    };

    this.acknowledgeByNotificationId = function (notificationId) {
        return notificationRepository.acknowledgeByNotificationId(notificationId);
    };

    this.acknowledgeByUserId = function (userId, type) {
        return notificationRepository.acknowledgeByUserId(userId, type);
    };

    this.countUnacknowledgedByUserId = function (userId, type, latest) {
        return notificationRepository.countUnacknowledgedByUserId(userId, type, latest);
    };

    this.markAsReadByNotificationId = function (notificationId, isRead) {
        return notificationRepository.markAsReadByNotificationId(notificationId, isRead);
    };

    this.markAllAsReadByUserId = function (userId, type) {
        return notificationRepository.markAllAsReadByUserId(userId, type);
    };

    this.countUnreadByUserId = function (userId, type, latest) {
        return notificationRepository.countUnreadByUserId(userId, type, latest);
    };

    this.resetUserRegistrations = function () {
        let promises = [];
        _.each(currentUserModel.getRegistrations(), function (url) {
            promises.push(registrationRepository.deleteRegistration(url));
        });
        currentUserModel.clearRegistrations();
        return $q.all(promises);
    };

    this.resetUserNotificationRegistrations = function (type) {
        let promises = [];
        _.each(currentUserModel.getNotificationRegistrations(type), function (url) {
            promises.push(registrationRepository.deleteRegistration(url));
        });
        currentUserModel.clearNotificationRegistrations(type);
        return $q.all(promises);
    };

    this.setChatVisibility = function (isVisible) {
        return chatRoomRepository.setChatVisibility(isVisible);
    };

    this.enterChat = function (submissionId) {
        return chatRoomRepository.enter(submissionId);
    };

    this.leaveChat = function (submissionId) {
        return chatRoomRepository.leave(submissionId);
    };

    this.ack = function () {
        return serverAckRepository.ack();
    };

    this.getLogoutUrl = isAutoLogout => {
        let logoutUrl;
        if(!isAutoLogout) {
            if ( appTypeConfigurationModel.isUnderwriterWorkstation() && !_.isEmpty(preferenceModel.get('system.urlUW'))) {
                logoutUrl = preferenceModel.get('system.urlUW');
            } else if (appTypeConfigurationModel.isAgentConsole() && !_.isEmpty(preferenceModel.get('system.urlAgent'))) {
                logoutUrl = preferenceModel.get('system.urlAgent');
            } else if (appTypeConfigurationModel.isAdminWorkstation() && !_.isEmpty(preferenceModel.get('system.urlAdmin'))) {
                logoutUrl = preferenceModel.get('system.urlAdmin');
            }
        } else {
            if ( appTypeConfigurationModel.isUnderwriterWorkstation() && !_.isEmpty(preferenceModel.get('system.urlDisconnectedUW'))) {
                logoutUrl = preferenceModel.get('system.urlDisconnectedUW');
            } else if (appTypeConfigurationModel.isAgentConsole() && !_.isEmpty(preferenceModel.get('system.urlDisconnectedAgent'))) {
                logoutUrl = preferenceModel.get('system.urlDisconnectedAgent');
            } else if (appTypeConfigurationModel.isAdminWorkstation() && !_.isEmpty(preferenceModel.get('system.urlDisconnectedAdmin'))) {
                logoutUrl = preferenceModel.get('system.urlDisconnectedAdmin');
            }
        }
        return logoutUrl;
    }
};

angular.module('umCore')
    .service('coreMediator', CoreMediator);
